<template>
  <v-tooltip top :disabled="disabled">
    <template v-slot:activator="{ on: textTooltip }"
      ><span
        v-if="text != null"
        v-bind:style="computedTextStyle"
        v-on="{ ...textTooltip }"
        >{{ text }}</span
      >
      <slot v-if="text == null" name="text"></slot>
    </template>
    <span v-if="tooltip != null" :style="tooltipStyle">{{ tooltip }}</span>
    <slot v-if="tooltip == null" name="tooltip"></slot>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TooltipText',

  computed: {
    computedTextStyle() {
      return this.underlined && !this.disabled
        ? { ...this.textStyle, 'text-decoration': 'underline' }
        : this.textStyle
    }
  },

  props: {
    text: {
      type: String,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    },
    textStyle: {
      type: Object,
      default: () => ({})
    },
    tooltipStyle: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    underlined: {
      type: Boolean,
      default: true
    }
  }
}
</script>
